import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../keys";
import { queryApi } from "../api";

const CREATOR_SUBSCRIPTION_PLANS_STALE_MS = 60 * 1000;

export function useCreatorSubscriptionPlansQuery(userId?: string) {
  return useQuery({
    queryKey: [...queryKeys.subscriptionPlans, "creator", userId ?? "unknown"],
    queryFn: () => queryApi.fetchCreatorSubscriptionPlans(userId as string),
    enabled: !!userId,
    staleTime: CREATOR_SUBSCRIPTION_PLANS_STALE_MS,
  });
}

